<template>
    <div class="quotation-settings-page">
        <app-sub-title text="Configuración de Categorías de Items" />
        <app-quotation-settings-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="quotation-setting-form"
            :title="!setting ? 'Crear Configuración' : 'Editar Configuración'"
            :on-close="() => $bus.$emit('quotation-setting-form.clear')"
        >
            <div slot="body">
                <app-quotation-setting-form
                    :selected-setting="setting"
                    :on-save="onSave"
                    id="quotation-setting-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="saving"
                    @click="saveSetting"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import itemsQuotationRepository from '../../../repositories/items-quotation.repository';
import SubTitle from '../../UI/Layout/SubTitle.vue';
import QuotationSettingsList from './QuotationSettingsList/QuotationSettingsList.vue';
import QuotationSettingForm from './QuotationSettingForm/QuotationSettingForm.vue';
import { mixin } from '../../../mixin';

export default {
    mixins: [mixin],
    components: {
        appSubTitle: SubTitle,
        appQuotationSettingsList: QuotationSettingsList,
        appQuotationSettingForm: QuotationSettingForm
    },
    data() {
        return {
            data: {
                data: [],
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0,
                per_page: 15
            },
            page: 1,
            filters: {},
            setting: null,
            sort: {
                sortBy: 'id',
                sortDir: 'asc'
            },
            saving: false
        };
    },
    methods: {
        loadSettings() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                page: this.page
            };
            const pr = { ...itemsQuotationRepository };
            pr.getItemCategorySettings(this.page, filters)
                .then(response => {
                    if (Array.isArray(response.data)) {
                        this.data = {
                            data: response.data,
                            current_page: 1,
                            last_page: 1,
                            from: response.data.length > 0 ? 1 : 0,
                            to: response.data.length,
                            total: response.data.length,
                            per_page: response.data.length || 15
                        };
                    } else {
                        this.data = response.data || {
                            data: [],
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0,
                            total: 0,
                            per_page: 15
                        };
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al cargar las configuraciones');
                });
        },
        onChangePage(page) {
            this.page = page;
            this.loadSettings();
        },
        onEdit(setting) {
            this.setting = setting;
            this.openForm();
        },
        saveSetting() {
            this.$bus.$emit('quotation-setting-form.save');
        },
        onSave() {
            this.closeForm();
            this.loadSettings();
        },
        openForm() {
            this.$bus.$emit('quotation-setting-form.open');
        },
        closeForm() {
            this.$bus.$emit('quotation-setting-form.close');
            this.setting = null;
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadSettings();
        },
    },
    created() {
        this.loadSettings();
    }
};
</script>

